<template>
    <div class="result-card">
        <figure class="result-card__figure">
            <img v-if="image !== null" :src="image?.imageUrl" :alt="title" loading="lazy" />
            <svgComponent
                v-else
                class-name="icon-no-image"
                :width="40"
                :height="40"
                icon-name="icon-regulations"></svgComponent>
        </figure>
        <div class="result-card__body">
            <header class="title">{{ title }}</header>
            <div class="info">
                {{ street }} {{ houseNumber }} <br />
                {{ postalCode }} {{ city }}
            </div>
            <div class="tags" v-if="courses">
                <div class="tag" v-for="(course, index) in courses" :key="`course-${index}`">
                    {{ course }}
                </div>
            </div>
            <a class="link" :href="url">
                <span>Ga naar: {{ title }}</span>
            </a>
        </div>
    </div>
</template>

<script setup lang="ts">
import svgComponent from '../../../components/svgComponent.vue';
import { IRidingSchool } from '../model/ridingschool.models';
defineProps<{
    id: IRidingSchool['umbracoId'];
    image?: IRidingSchool['image'];
    title: IRidingSchool['title'];
    street?: IRidingSchool['street'];
    houseNumber?: IRidingSchool['houseNumber'];
    postalCode?: IRidingSchool['postalCode'];
    city?: IRidingSchool['city'];
    url?: IRidingSchool['url'];
    courses?: IRidingSchool['courses'];
}>();
</script>
